<template>
  <div class="search-detaile law-page">
    <Search/>
    <div class="breadcrumb-wrap">
      <div class="container">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
    </div>
    <div class="container">
      <div class="position">
        <div class="bg-white p-20">
          <LawSearch
            v-bind:data="data"
            @searchLaw="getDataSearch($event)"
            @resetLaw="resetDataSearch($event)"
          />
          <div class="search-body">
            <div class="search-result">
              <div>
                <div class="search-result-body">
                  <mq-layout mq="laptop">
                    <div class="type-column">
                      <v-btn @click="printWord" v-if="items.length" class="btn-print-word">{{ $t("Печать в Word") }}
                      </v-btn>
                      <v-simple-table v-if="items.length">
                        <thead>
                        <tr>
                          <th v-for="tableField in tableFields" :key="tableField.field" :colspan="tableField.colspan">
                            <template v-if="tableField.sort">
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + tableField.text" @click.prevent="sortData(tableField.field)">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>
                                {{ tableField.text }}
                              </a>
                            </template>
                            <template v-else>
                              <a>
                                {{ tableField.text }}
                              </a>
                            </template>
                          </th>
                        </tr>
                        </thead>
                        <LawTable
                          v-bind:lawItems="items"
                        />
                      </v-simple-table>
                    </div>
                  </mq-layout>
                  <mq-layout mq="mobile">
                  </mq-layout>
                </div>
                <div class="search-result-footer">
                  <p>{{ $t("Общее количество законов") }}: {{ itemsTotal }}</p>
                </div>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="pagesCount"
              :total-visible="7"
              :aria-label="$t('Страницы результатов поиска')"
            />
          </div>
          <div class="statistic">
            <h3>{{ $t('Статистика исполнения законов') }}</h3>
            <div class="law-statistic-item">
              <div class="item-head">
                <v-list-item
                  v-bind:key="y.transName"
                  v-for="y in data.years"
                  @click="statisticLaw(y.transName)"
                  v-bind:class="{ active: yearActive[y.transName] }"
                >
                  <v-list-item-title>{{ y.transName }}</v-list-item-title>
                </v-list-item>
                <HtmlToWord
                  v-if="statisticItems.length"
                  :fileName="'statistic'"
                  :htmlTitle="'<h3>'+$t('Статистика исполнения законов')+'</h3><br/>'"
                  :htmlContent="$refs.statisticTable"
                />
              </div>
              <div class="table-overflow">
                <v-simple-table ref="statisticTable" v-if="statisticItems.length">
                  <tr v-bind:key="statisticItem.name" v-for="statisticItem in statisticItems">
                    <td>{{ statisticItem.name }}</td>
                    <td>{{ statisticItem.count }}</td>
                  </tr>
                </v-simple-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Law from '@/model/law'
  import CMS from '@/model/cms'
  import Search from '@/components/Search'
  import LawTable from '@/components/law/LawTable'
  import LawSearch from '@/components/law/LawSearch'
  import HtmlToWord from '@/components/app/HtmlToWord'
  import {mapMutations} from 'vuex'
  import {Trans} from "@/plugins/Translation"

  export default {
    components: {
      Search,
      LawTable,
      LawSearch,
      HtmlToWord
    },
    data: () => ({
      breadcrumbs: [],
      tableFields: [],
      sortSettings: {},
      items: [],
      itemsTotal: 0,
      page: 1,
      pagesCount: 1,
      search: {},
      data: [],
      statisticItems: [],
      year: null,
      yearActive: [],
      title: '',
      description: '',
      keywords: '',
      menu: ''
    }),
    metaInfo () {
      return {
        title: this.title,
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.description,
        }, {
          vmid: 'keywords',
          name: 'keywords',
          content: this.keywords,
        }]
      }
    },
    watch: {
      $route: 'fetchData',
      page() {
        this.searchLaw()
      }
    },
    created() {
      this.fetchData()
      this.scrollToTop()
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        CMS.loadMenuBySlug(this.$route.params.slug)
          .then((response) => {
            this.breadcrumbs = [
              {
                text: this.$i18n.t('Главная'),
                disabled: false,
                href: Trans.currentLocaleUrl + '/'
              }
            ]
            this.menu = response.data
            if (this.menu) {
              var breadcrumb = {}
              breadcrumb.text = this.menu.transTitle
              breadcrumb.disabled = true
              this.breadcrumbs.push(breadcrumb)
              this.title = this.menu.transTitleSeo
              this.description = this.menu.transDescription
              this.keywords = this.menu.transKeywords
            }

            Law.getLawData().then((response) => {
              this.data = response.data
              this.year = this.data.year
              this.breadcrumbs = [
                {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
                {text: this.$i18n.t('Исполнение законов'), disabled: true}
              ]
              this.tableFields = [
                {field: 'id', text: 'ID', colspan: 1, sort: true},
                {field: 'name', text: this.$i18n.t('Сведение о Законе КР (наименование на двух языках, № от (дата принятия)'), colspan: 1, sort: true},
                {field: 'effectiveDate', text: this.$i18n.t('Дата вступления'), colspan: 1, sort: true},
                {field: 'developers', text: this.$i18n.t('Требует ли принятие решений'), colspan: 2, sort: false},
                {field: 'npas', text: this.$i18n.t('НПА во исполнение закона'), colspan: 1, sort: false},
                {field: 'stage', text: this.$i18n.t('Стадия'), colspan: 1, sort: false},
                {field: 'note', text: this.$i18n.t('Стадия'), colspan: 1, sort: false}
              ]
              this.setLoading(false)
              this.searchLaw()
              this.statisticLaw(this.year)
            })
              .catch((error) => {
                this.setLoading(false)
                console.log(error)
              })
          })
          .catch((error) => {
            this.setLoading(false)
            console.log(error)
          })
      },
      getDataSearch(search) {
        this.search = {...this.search, ...search}
        this.page = 1
        this.searchLaw()
      },
      resetDataSearch() {
        this.search = {}
        this.page = 1
        this.searchLaw()
      },
      // поиск законов
      searchLaw() {
        this.setLoading(true)
        this.search.page = this.page
        Law.getList('public', this.search)
          .then((response) => {
            this.items = response.items
            const paginator = response.paginationData
            this.itemsTotal = paginator.totalCount
            this.pagesCount = paginator.pageCount
          })
          .catch((error) => {
            console.log(error)
          })

        this.setLoading(false)
      },
      // статистика по году
      statisticLaw(year) {
        this.setLoading(true)
        Law.getStatisticList(year)
          .then((response) => {
            this.yearActive = []
            this.yearActive[year] = true
            this.statisticItems = response.statistic
            this.statisticContent = '<h3>'+this.$i18n.t('Статистика исполнения законов')+'</h3><br/>' + this.$refs['statisticTable'].$el.innerHTML
          })
          .catch((error) => {
            console.log(error)
          })

        this.setLoading(false)
      },
      sortData(sortKey) {
        if (
          !this.sortSettings[sortKey] ||
          this.sortSettings[sortKey] === 'desc'
        ) {
          this.sortSettings[sortKey] = 'asc'
        } else {
          this.sortSettings[sortKey] = 'desc'
        }

        this.page = 1
        this.search = {...this.search, ...{page: this.page, orderBy: sortKey, orderDir: this.sortSettings[sortKey]}}
        this.searchLaw()
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      },
      // печать в ворд исполнения законов
      printWord() {
        this.setLoading(true)
        let param = ''

        for (let field in this.search) {
          param += `${field}=${this.search[field]}&`
        }

        Law.printLawTable(param)
          .then(response => {
            this.forceFileDownload(response)
          }).catch(() => console.log('error occured'))

        this.setLoading(false)
      },
      // генерация ссылки для скачивания ворд файла
      forceFileDownload(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'law-list.docx')
        document.body.appendChild(link)
        link.click()
      }
    }
  }
</script>
